import { Component, Inject, OnInit } from '@angular/core';
import { ProtocolQ, ProtocolQGeneralData } from '../../../../model/protocol';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SpinnerService } from '../../../../services/spinner.service';
import { ProtocolUtils } from '../../../../utils/protocolUtils';
import { TranslateService } from '@ngx-translate/core';
import { quillConfig } from '../../../../quill-config';
import { ProtocolQTestGeneralDataService } from '../../../../services/protocolQTestGeneralData.service';
import { Subject, takeUntil } from 'rxjs';

export interface DialogSectionTemplate {
  protocolData: ProtocolQGeneralData;
  nameClient: string;
  protocol: ProtocolQ;
}

@Component({
    selector: 'app-protocol-q-edit-section-template',
    templateUrl: './protocol-q-edit-section-template.component.html',
    styleUrls: ['./protocol-q-edit-section-template.component.scss'],
    standalone: false,
})
export class ProtocolQEditSectionTemplateComponent implements OnInit {

  scopeTab = false;
  targetTab = false;
  precedentsTab = false;

  quillConfig = {
    toolbar: quillConfig.toolbar_not_image,
    blotFormatter2: quillConfig.blotFormatter2,
  };

    private destroy$ = new Subject<void>();

  constructor(private dialogRef: MatDialogRef<ProtocolQEditSectionTemplateComponent>,
    private spinnerService: SpinnerService,
    private protocolQTestGeneralDataService: ProtocolQTestGeneralDataService,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: DialogSectionTemplate) { }

  ngOnInit(): void {
  }

  onOkClick(): void {
    this.dialogRef.close(this.data.protocolData);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  refreshScope(): void {
		this.spinnerService.show();
    this.data.protocolData.scope = ProtocolUtils.getScopeQualificates(this.data.protocol, this.data.protocol.nameClient, this.data.protocol.clientAddress, this.translate);
    this.spinnerService.hide();
  }

  refreshTarget(): void {
		this.spinnerService.show();
    this.data.protocolData.target = ProtocolUtils.getTargetQualificates(this.data.protocol, this.data.protocol.nameClient, this.translate);
    this.spinnerService.hide();
  }

  refreshPrecedents(): void {
		this.spinnerService.show();
    this.data.protocolData.precedents = ProtocolUtils.getBackgroundQualificates(this.data.protocol, this.data.protocol.nameClient, this.translate);
    this.spinnerService.hide();
  }

  refreshStrategyQualification(): void {
		this.spinnerService.show();

    this.protocolQTestGeneralDataService.loadBase64ImageStrategy().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      this.data.protocolData.strategyQualification = ProtocolUtils.getStrategyQualificates(this.data.protocol, this.data.protocol.nameClient, this.translate, result);
      this.spinnerService.hide();
    });
  }

  refreshClientResponsibility(): void {
		this.spinnerService.show();
    this.data.protocolData.clientResponsibility = this.translate.instant('protocolEdit.clientResponsibility');
    this.spinnerService.hide();
  }

  refreshEngineeringResponsibility(): void {
		this.spinnerService.show();
    this.data.protocolData.clientResponsibility = this.translate.instant('protocolEdit.engineeringResponsibility');
    this.spinnerService.hide();
  }

}
